/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OnboardingStatus {
    StartedByCustomer = 'StartedByCustomer',
    InviteSent = 'InviteSent',
    ReadyForCheck = 'ReadyForCheck',
    Done = 'Done'
  }

    export const OnboardingStatusTranslocoMap: Record<OnboardingStatus, string> = {
    [OnboardingStatus.StartedByCustomer]: 'onboardingStatus.startedByCustomer',
    [OnboardingStatus.InviteSent]: 'onboardingStatus.inviteSent',
    [OnboardingStatus.ReadyForCheck]: 'onboardingStatus.readyForCheck',
    [OnboardingStatus.Done]: 'onboardingStatus.done',
    };

    export const OnboardingStatusOptions = [
  { value: OnboardingStatus.StartedByCustomer, labelKey: 'onboardingStatus.startedByCustomer' },
  { value: OnboardingStatus.InviteSent, labelKey: 'onboardingStatus.inviteSent' },
  { value: OnboardingStatus.ReadyForCheck, labelKey: 'onboardingStatus.readyForCheck' },
  { value: OnboardingStatus.Done, labelKey: 'onboardingStatus.done' },
    ];

